import { Controller } from "@hotwired/stimulus";

var HubFilesFormController = class extends Controller {
  connect() {
    this.syncFileName();
  }

  fileChanged() {
    this.syncFileName();
  }

  syncFileName() {
    if (!this.hasFileNameTarget || !this.hasFileInputTarget) {
      return;
    }

    var file = this.fileInputTarget.files[0];
    if (file) {
      this.fileNameTarget.textContent = file.name;
    }
  }
};

HubFilesFormController.targets = ["fileInput", "fileName"];

export default HubFilesFormController;
